<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/dayi/1/base.png" alt="" />
      <div class="technological-process">
        <!-- <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            “蓉城人才绿卡”大邑卡旨在进一步完善高层次人才服务保障体系，建立人才服务绿色通道，通过向符合条件的高层次人才发放绿卡，为其提供高效、便捷、优质的服务，进一步激发人才创新创业活力，助力大邑经济社会发展。“蓉城人才绿卡”大邑卡是符合发放条件的各级各类人才在大邑县域内依照相关规定享受政务、创新创业、商务和生活等专属服务保障的有效凭证。
          </div>
        </div> -->
        <div class="zccl">
          <img class="top" src="../../assets/imgs/dayi/1/title1.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）为深入实施人才优先发展战略，进一步优化人才发展环境，吸引和集聚一批高层次专家人才，助推县域经济发展，根据《成都市“蓉城人才绿卡”管理办法（试行）》相关要求，结合我县人才工作实际，特制定本办法。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二） “蓉城人才绿卡”大邑卡旨在进一步完善高层次人才服务保障体系，建立人才服务绿色通道，通过向符合条件的高层次人才发放绿卡，为其提供高效、便捷、优质的服务，进一步激发人才创新创业活力，助力大邑经济社会发展。“蓉城人才绿卡”大邑卡是符合发放条件的各级各类人才在大邑县域内依照相关规定享受政务、创新创业、商务和生活等专属服务保障的有效凭证。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）“蓉城人才绿卡”大邑卡在县委人才工作领导小组的领导下，由县委人才办负责宏观管理和统筹协调，由县级有关部门按照职责分工和服务事项，相互配合分头实施，共同做好“蓉城人才绿卡”大邑卡所提供服务的保障工作。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/dayi/1/title2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）“大邑人才绿卡”发放对象的工作关系在大邑县，遵守中华人民共和国法律法规，具有良好职业道德和社会形象，本人对所在行业领域具有突出贡献或重大影响力，获得过重大荣誉称号，包括《成都市人才分类目录》D类以上人才，“安邑人才”创新项目人选，大邑公共类事业单位引进人才，其他根据我县经济社会发展需要及人才队伍建设需要，经推荐由县委人才工作领导小组认定的各类急需紧缺人才。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二） 县委人才办根据大邑县经济社会发展和人才队伍建设实际需要，可对服务对象及服务事项适时优化调整，及时更新发布“大邑人才绿卡”服务事项目录。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/dayi/1/title3.png" alt="" />
          <div class="content" style="background-color: #fff">
             “蓉城人才绿卡”大邑卡以人才需求为导向，在统筹公共服务资源的基础上，适时引入金融、交通出行、医疗保健等各类市场化资源，为持有人提供政务办理、创新创业、商务服务、生活服务等具有本地特色的服务事项，积极构建全链条的人才服务体系，打造互利互惠、共建共享的人才发展生态圈。
          </div>
        </div>
        <div class="part-four">
          <img
            src="../../assets/imgs/dayi/1/title4.png"
            class="part-two-title-img"
          />

          <div class="main-content" style="padding-top: 0.2rem">
            <div
              style="
                color: #333;
                font-size: 0.26rem;
                margin-bottom: 0.8rem;
                text-align: left;
                font-weight: 600;
              "
            >
              “蓉城人才绿卡”大邑卡申领按以下程序进行：
            </div>
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                符合申领条件的高层次人才，向各行业主管部门提交《“蓉城人才绿卡”大邑卡申领表》（一式两份，见附件3）和相关证明材料。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">初审</div>
              </div>
              <div class="part-four-content1">
                由行业主管部门对申领人资格进行初审，提出初审意见。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">复核</div>
              <div class="part-four-content1">
                县委人才办会同县级有关部门、产业功能区、镇（街道），按服务管理权限对初审通过的人员资料进行复核。
              </div>
            </div>
            <div
              class="part-four-items"
              style="border: none; margin-bottom: 0rem"
            >
              <div class="title-bg title-bg4">批准发卡</div>
              <div class="part-four-content1">
                根据审批结果，县委人才办及时完成制卡工作，由行业主管部门负责发卡。
              </div>
            </div>
          </div>
          <div
            class="main-content"
            style="
              font-size: 0.26rem;
              text-align: left;
              padding: 0.2rem;
              margin: 0.2rem 0;
              line-height: 0.44rem;
            "
          >
            县委人才办依据“蓉城人才绿卡”大邑卡服务内容，统一编制服务手册。相关服务涉及的部门和单位要认真梳理服务内容，规范服务流程，明确服务事项、办理程序、受理材料、办结时限和责任人。要设立绿色通道，亮出服务标识，建立人才服务专员制度，对重点人才（团队）项目提供“一对一”人才专员服务。
          </div>
          <div
            class="main-content"
            style="
              font-size: 0.26rem;
              text-align: left;
              padding: 0.2rem;
              margin: 0.2rem 0;
              line-height: 0.44rem;
            "
          >
             持卡人提出的服务需求，能够线上办理的，本人可直接登陆“蓉城人才综合服务平台”大邑县服务板块，按照相应流程办理；不能够线上办理的，本人凭“蓉城人才绿卡”及相关材料到有关部门或单位通过绿色通道办理，有关部门和单位应在3个工作日内办结，并将办理情况反馈持卡人。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/dayi/1/title5.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一） “蓉城人才绿卡”大邑卡持卡有效期视各类人才所获荣誉称号而定，《成都市人才分类目录》D类以上人才享受10年，其他类别享受5年。人才管理期到期后，由持卡人向县委人才办提出续期申请，符合条件的换发新卡。持卡期间，若持卡人工作关系离开大邑，卡片自动注销。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）申领“蓉城人才绿卡”大邑卡相关材料的真实性由本人负责，凡弄虚作假者一经发现，取消其相关申请资格，且不得再次申请。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三） “蓉城人才绿卡”大邑卡持卡人在卡片有效期内出现违法、违纪或违反其他相关规定，取消其绿卡持有资格并对其持有卡片进行注销处理。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （四） “蓉城人才绿卡”大邑卡如遗失，持卡人应及时将情况向县委人才办反映并挂失，再按规定申请补办。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （五） “蓉城人才绿卡”大邑卡仅限持卡人本人使用，不得出借、租让、赠与、转让他人使用。违反上述规定者，取消其绿卡持有资格并对其持有卡片进行注销处理。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/dayi/1/title6.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一） 建立“蓉城人才绿卡”大邑卡联席会议制度。联席会议由县委人才办根据工作需要，指定相关单位不定期召集，统筹解决“蓉城人才绿卡”大邑卡需要协调的各类重大事项。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）县委人才办负责“蓉城人才绿卡”大邑卡的日常管理，协调县级有关部门、产业功能区、镇（街道）畅通绿色通道，做好相关服务工作，督导落实有关政策待遇。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）县委人才办建立持卡人信息数据库，持卡人办理服务事项时，通过“蓉城人才综合服务平台”终端核实信息后予以办理。
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/dayi/1/title7.png" alt="" />
          <div class="content">
            <div class="item">
              <div class="circle"></div>
              <div>
                各有关职能部门根据部门职责形成工作机制，提高服务意识，见卡能识，见卡即办。
              </div>
            </div>
            <div class="item">
              <div class="circle"></div>
              <div>
                本办法由县委人才办负责解释，具体服务由各相关服务提供单位解释。
              </div>
            </div>
            <div class="item">
              <div class="circle"></div>
              <div class="fj">
                <div>附件：</div>
                <div @click="download">
                  <div style="margin-bottom: 0.2rem; color: #0839b7">
                    1.“蓉城人才绿卡”大邑卡服务事项
                  </div>
                  <div style="color: #0839b7">2.“蓉城人才绿卡”大邑卡申领表</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {
    download() {
      const a = document.createElement("a");
      a.href = "./file/dayi/file.docx";
      a.download = "“蓉城人才绿卡”大邑卡服务事项.docx";

      console.log(a);

      a.click();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.item {
  display: flex;
  font-weight: normal;
  margin-bottom: 0.2rem;

  .circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
    margin-right: 0.08rem;
    flex-shrink: 0;
    margin-top: 0.05rem;
  }
  .fj {
    display: flex;
  }
}

.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;
    color: #4e4e4e;
    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 5.59rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
